// src/components/sampleorders/SampleOrderCommentsService.js
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";

export const SampleOrderCommentsService = {
  subscribe(companyId, sampleOrderId, onItems, onError) {
    if (!companyId || !sampleOrderId) return () => {};

    const ref = collection(
      db,
      "companies",
      companyId,
      "sampleOrders",
      sampleOrderId,
      "comments"
    );

    // Match TaskCommentsPanel behavior (oldest -> newest)
    // If you previously ordered by createdAtMs, this still works because we write createdAt.
    const q = query(ref, orderBy("createdAt", "asc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const items = snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
        onItems?.(items);
      },
      (err) => {
        console.error("[SampleOrderCommentsService] subscribe error:", err);
        onError?.(err);
      }
    );

    return unsub;
  },

  async addComment(companyId, sampleOrderId, data) {
    if (!companyId || !sampleOrderId) throw new Error("Missing companyId/sampleOrderId.");

    const text = String(data?.text || "").trim();
    if (!text) throw new Error("Comment text is required.");

    const createdBy = data?.createdBy || null;
    if (!createdBy) throw new Error("Missing createdBy (uid).");

    const createdAtMs = Date.now();

    // ✅ RULES-FRIENDLY REQUIRED FIELDS
    const payload = {
      companyId: companyId,
      entityType: "sampleOrder",
      entityId: sampleOrderId,

      text,
      textPlain: String(data?.textPlain || "").trim(),
      mentionedUserIds: Array.isArray(data?.mentionedUserIds) ? data.mentionedUserIds : [],

      createdBy,
      createdByName: data?.createdByName || null,
      createdByRole: data?.createdByRole || null,

      createdAt: serverTimestamp(),
      createdAtMs,
      updatedAt: serverTimestamp(),
    };

    const ref = collection(
      db,
      "companies",
      companyId,
      "sampleOrders",
      sampleOrderId,
      "comments"
    );

    const docRef = await addDoc(ref, payload);
    return docRef.id;
  },

  async deleteComment(companyId, sampleOrderId, commentId) {
    if (!companyId || !sampleOrderId || !commentId) throw new Error("Missing ids for delete.");
    const ref = doc(
      db,
      "companies",
      companyId,
      "sampleOrders",
      sampleOrderId,
      "comments",
      commentId
    );
    await deleteDoc(ref);
  },
};

export default SampleOrderCommentsService;
